import alimentacao from '../assets/cartoes/alimentacao.svg';
import auto from '../assets/cartoes/auto.svg';
import auxilioAlimentacao from '../assets/cartoes/auxilioalimentacao.png';
import cesta from '../assets/cartoes/cesta.png';
import compras from '../assets/cartoes/compras.svg';
import cultura from '../assets/cartoes/cultura.png';
import natal from '../assets/cartoes/natal.svg';
import refeicao from '../assets/cartoes/refeicao.svg';
import saude from '../assets/cartoes/saude.png';

export default function getImagemProduto(codigo) {
  switch (codigo) {
    case '00027':
      return alimentacao;
    case '00031':
      return refeicao;
    case '00028':
      return auto;
    case '00030':
      return cultura;
    case '00203':
      return compras;
    case '00201':
      return cesta;
    case '00202':
      return natal;
    case '00204':
      return auxilioAlimentacao;
    case '00205':
      return saude;
    default:
      return null;
  }
}
